import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import CtaArticleSection from './components/CtaArticleSection';
import FeatureGrid from './components/FeatureGrid';
import FaqSection from './components/FaqSection';
import SeoArticlesSection from './components/SeoArticlesSection';

const siteUrl = (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_SITE_URL) || 'https://cssbuyspreadsheet.guru';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        {/* Schema.org WebSite */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'WebSite',
              name: 'CSSBuy Spreadsheet',
              url: siteUrl,
              description: 'O melhor CSSBuy Spreadsheet atualizado em 2026. Links verificados, vendedores confiáveis e milhares de produtos organizados.',
              inLanguage: 'pt',
            }),
          }}
        />

        {/* Schema.org Organization */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'Organization',
              name: 'cssbuyspreadsheet.guru',
              url: siteUrl,
              description: 'CSSBuy Spreadsheet - Planilha atualizada com links verificados e produtos recomendados',
              logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/d367cf6745ee47f3fc82c76d3a54c50c.png',
            }),
          }}
        />

        {/* Schema.org BreadcrumbList */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'BreadcrumbList',
              itemListElement: [
                { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
              ],
            }),
          }}
        />

        {/* Schema.org FAQPage */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: [
                {
                  '@type': 'Question',
                  name: 'O CSSBuy Spreadsheet é seguro?',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: 'Sim, nosso CSSBuy Spreadsheet é completamente seguro. Todos os links são verificados manualmente por nossa equipe antes de serem adicionados.',
                  },
                },
                {
                  '@type': 'Question',
                  name: 'Como usar o CSSBuy Spreadsheet?',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: 'Basta selecionar a categoria desejada no menu de navegação, clicar no produto que lhe interessa, e você será redirecionado para a página de compra no CSSBuy.',
                  },
                },
                {
                  '@type': 'Question',
                  name: 'Com que frequência a planilha é atualizada?',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: 'Nossa planilha CSSBuy é atualizada diariamente. Monitoramos a disponibilidade de produtos e adicionamos novos links constantemente.',
                  },
                },
                {
                  '@type': 'Question',
                  name: 'Posso confiar nos vendedores listados?',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: 'Sim, todos os vendedores passam por verificação rigorosa. Avaliamos histórico de vendas e qualidade antes de incluir na lista.',
                  },
                },
                {
                  '@type': 'Question',
                  name: 'O CSSBuy Spreadsheet funciona em Portugal?',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: 'Sim, é totalmente funcional para Portugal. Os links levam ao CSSBuy que oferece envio internacional com rastreamento completo.',
                  },
                },
                {
                  '@type': 'Question',
                  name: 'Quanto posso economizar usando a planilha?',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: 'Em média, usuários economizam entre 30% e 60% comparado a compras diretas, graças à comparação de preços entre vendedores.',
                  },
                },
              ],
            }),
          }}
        />

        <HeroSection />
        <CategoryGrid />
        <AboutSection />
        <CtaArticleSection />
        <SeoArticlesSection />
        <FeatureGrid />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}